import '@angular/localize/init';
import { init } from '@module-federation/enhanced/runtime';
import { mfeErrorPlugin } from './mfe-error.plugin';

async function validateRemote(
    name: string,
    entry: string,
    timeoutMs = 5000
): Promise<{ name: string; entry: string } | null> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    try {
        const response = await fetch(entry, {
            method: 'GET',
            cache: 'no-store',
            signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (response.ok) {
            return { name, entry };
        }
        console.warn(`Remote "${name}" manifest not accessible at ${entry} (status: ${response.status})`);
        return null;
    } catch (error) {
        clearTimeout(timeoutId);
        if (error instanceof Error && error.name === 'AbortError') {
            console.warn(`Remote "${name}" validation timed out after ${timeoutMs}ms:`, entry);
        } else {
            console.warn(`Remote "${name}" validation failed:`, error);
        }
        return null;
    }
}

fetch('/module-federation.manifest.json')
    .then((res) => res.json())
    .then((remotes: Record<string, string>) => Object.entries(remotes))
    .then(async (remoteEntries) => {
        // Validate all remotes in parallel
        const validationResults = await Promise.all(remoteEntries.map(([name, entry]) => validateRemote(name, entry)));
        // Filter out failed remotes
        return validationResults.filter((remote): remote is { name: string; entry: string } => remote !== null);
    })
    .then((remotes) => {
        return init({ name: 'host', remotes, plugins: [mfeErrorPlugin] });
    })
    .then(() => import('./bootstrap').catch((err) => console.error(err)));
